import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';
import { ViewportService } from '@core/services/viewport.service';
import { environment } from '@/environments/environment';
import { PlatformAppContext } from '@/app/platform/platform-context/platform-app-context';
import { LAYOUT_ACTIONS, LAYOUT_QUERIES, LayoutActions, LayoutQueries } from '@core/store/types';
import { USER_QUERIES, UserQueries } from '@/app/platform/platform-core/user/store/types';
import { ApplicationService } from '@/app/application.service';

@Component({
    selector: 'egi-navbar2',
    templateUrl: './egi-navbar2.component.html',
    styleUrls: ['./egi-navbar2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EgiNavbar2Component {

  constructor(
    public readonly egiAppContext: PlatformAppContext,
    @Inject(LAYOUT_ACTIONS)
    readonly layoutActions: LayoutActions,
    @Inject(LAYOUT_QUERIES)
    readonly layoutQueries: LayoutQueries,
    @Inject(USER_QUERIES)
    public readonly userQueries: UserQueries,
    readonly appService: ApplicationService
  ) {}

  showApplicationDialog = false;
  readonly envBadge = environment.badge;
  /** Phone: compact "MiM"-logo i.p.v. de volledige naam (finetune 2026-09-15). */
  protected readonly viewport = inject(ViewportService);
  toggleSideBar() {
    this.layoutActions.toggleSideBar();
  }

  onLogoClick() {
    this.showApplicationDialog = true;
  }
}
